module.exports = __webpack_public_path__ + "img/1.5a5b2070.jpg";